export const RECEIVE_BREACHES_AND_SCAMS_DATA = "RECEIVE_BREACHES_AND_SCAMS_DATA";
export const SHOW_LOADER = "SHOW_BREACH_SCAM_SERVICE_LOADER";

export interface IBreachesAndScamsState {
    breachesAndScamsData?: BreachesAndScamsData[];
    isLoading: boolean;
}

export interface BreachesAndScamsData {
    title?: string;
    summary?: string;
    author?: string;
    feedUrl?: string;
    imageUrl?: string;
    publishDate?: string;
}

export interface GetBreachesAndScamsDataAction {
    type: "RECEIVE_BREACHES_AND_SCAMS_DATA";
    breachesAndScamsData: BreachesAndScamsData[];
}
export interface ShowAction {
    type: "SHOW_BREACH_SCAM_SERVICE_LOADER";
    isLoading: boolean;
}

export type KnownAction = GetBreachesAndScamsDataAction | ShowAction;
